import { Link } from "react-router-dom";
import { motion } from "framer-motion";

export default function ProductCard({ product, index = 0 }) {
  const from = Math.min(...product.tiers.map((t) => t.price));
  return (
    <motion.div
      initial={{ opacity: 0, y: 50 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-60px" }}
      transition={{ duration: 0.7, delay: (index % 3) * 0.08, ease: [0.16, 1, 0.3, 1] }}
    >
      <Link to={`/produit/${product.slug}`} data-testid={`product-card-${product.slug}`} className="group block">
        <div className="relative overflow-hidden bg-[#ebebea] aspect-[4/5]">
          <img
            src={product.image}
            alt={product.name}
            loading="lazy"
            className="w-full h-full object-cover grayscale-[0.15] group-hover:grayscale-0 group-hover:scale-[1.05] transition-all duration-700 ease-out"
          />
          <span className="absolute top-4 left-4 font-mono text-[10px] uppercase tracking-widest bg-black text-white px-2 py-1">
            {product.category}
          </span>
          <div className="absolute inset-x-0 bottom-0 translate-y-full group-hover:translate-y-0 transition-transform duration-500 bg-[#0044ff] text-white text-center py-3 font-bold uppercase tracking-widest text-xs">
            Personnaliser →
          </div>
        </div>
        <div className="flex items-baseline justify-between mt-4">
          <h3 className="font-display font-bold text-2xl tracking-tight">{product.name}</h3>
          <span className="font-mono text-sm text-[#555]">dès {from} €</span>
        </div>
        <p className="text-sm text-[#555] mt-1">{product.tagline}</p>
      </Link>
    </motion.div>
  );
}
